export default __webpack_public_path__ + "static/media/background.b9609e32.png";